import { Component, Vue } from 'vue-property-decorator';

@Component
export default class KidsLimitMixin extends Vue {
  get userProfile(): any {
    return this.$store.state.user.profile;
  }

  get quantityUserChildren(): number {
    const { children } = this.$store.state.user;
    if (children && Array.isArray(children)) return children.length;
    return 0;
  }

  get kidsLimit(): number {
    const { userProfile } = this;
    if (userProfile && userProfile.kids_limit) return userProfile.kids_limit;
    return 100;
  }

  get noKidsLimit(): boolean {
    const { userProfile } = this;
    return userProfile && userProfile.no_kids_limit;
  }

  get canAddChild(): boolean {
    const { kidsLimit, quantityUserChildren, noKidsLimit } = this;
    if (noKidsLimit) return true;
    return kidsLimit > quantityUserChildren;
  }
}



// WEBPACK FOOTER //
// ./src/mixins/kidsLimitMixin.ts